export default import.meta.ROLLDOWN_FILE_URL_gDLUAzRU55KKid46nqVi3w